<template>
  <div>
    <b-modal v-model="modalError" id="modal-feedback-error" hide-footer hide-header centered :no-enforce-focus="true">
      <img src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/criac%CC%A7a%CC%83o-erro.png"
           alt="Algo está errado">

      <div v-html='apiError'></div>
    </b-modal>

    <b-modal v-model="modalLoading" id="modal-feedback-loading" hide-footer hide-header centered :no-enforce-focus="true">
      <b-row>
        <b-col sm="12">
          <b-col class="text-center" sm="12">
            <img src="https://jaleko-files.s3.sa-east-1.amazonaws.com/img/gif.gif" alt="Carregando">
            <p>Aguarde! Estamos {{ isUpdate ? 'editando' : 'criando' }} o seu cronograma :)</p>
          </b-col>
        </b-col>
      </b-row>
    </b-modal>

    <div class="step-header">
      <h2 class="step-title">Defina os dias e horários do seu cronograma</h2>
    </div>

    <b-row>
      <b-col lg="6">
        <div class="date-time-picker">
          <span>Data de início e fim dos estudos: </span>

          <v-menu ref="dateMenu" v-model="dateMenu" :close-on-content-click="false" :return-value.sync="dateRange"
                  transition="scale-transition" offset-y min-width="auto">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field v-model="dateRangeText" prepend-inner-icon="mdi-calendar-blank" readonly v-bind="attrs"
                            v-on="on" placeholder="dd/mm/aa - dd/mm/aa" outlined dense color="#7C56F6"
                            hide-details class="mt-3"/>
            </template>

            <v-date-picker v-model="dateRange" locale="pt-BR" range no-title scrollable color="#7C56F6"
                           @change="validateStudyTime">
            </v-date-picker>
          </v-menu>
        </div>
      </b-col>

      <b-col lg="6">
        <div class="date-time-picker">
          <span>Horas de estudo por dia:</span>

          <v-menu ref="timeMenu" v-model="timeMenu" :close-on-content-click="false" :nudge-right="40"
                  transition="scale-transition" offset-y max-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field :value="studyTime" placeholder="00:00" prepend-inner-icon="mdi-clock-outline" readonly
                            dense v-bind="attrs" v-on="on" hide-details outlined color="#7C56F6" class="mt-3"/>
            </template>

            <div class="time-menu-content">
              <b-form-spinbutton id="sb-vertical" v-model="hours" vertical min="1" max="12"
                                 @input="validateHoursMinutes"/>
              <span class="ml-1 mr-4">h</span>

              <b-form-spinbutton id="sb-vertical" v-model="minutes" vertical min="0" max="59" step="5"
                                 @input="validateHoursMinutes"/>
              <span class="ml-1">min</span>
            </div>
          </v-menu>
        </div>
      </b-col>
    </b-row>

    <div class="step-question-container mt-8">
      <span class="step-question">Escolha os dias da semana que irá estudar</span>

      <v-btn-toggle class="day-check-container" color="#7C56F6" multiple v-model="weekDays"
                    @change="validateStudyTime">
        <v-btn outlined class="btn day-check-button" :value="1">
          <v-icon class="day-check-icon" v-if="weekDays.includes(1)">mdi-check</v-icon>
          Segunda
        </v-btn>

        <v-btn outlined class="btn day-check-button" :value="2">
          <v-icon class="day-check-icon" v-if="weekDays.includes(2)">mdi-check</v-icon>
          Terça
        </v-btn>

        <v-btn outlined class="btn day-check-button" :value="3">
          <v-icon class="day-check-icon" v-if="weekDays.includes(3)">mdi-check</v-icon>
          Quarta
        </v-btn>

        <v-btn outlined class="btn day-check-button" :value="4">
          <v-icon class="day-check-icon" v-if="weekDays.includes(4)">mdi-check</v-icon>
          Quinta
        </v-btn>

        <v-btn outlined class="btn day-check-button day-friday" :value="5">
          <v-icon class="day-check-icon" v-if="weekDays.includes(5)">mdi-check</v-icon>
          Sexta
        </v-btn>

        <v-btn outlined class="btn day-check-button" :value="6">
          <v-icon class="day-check-icon" v-if="weekDays.includes(6)">mdi-check</v-icon>
          Sábado
        </v-btn>

        <v-btn outlined class="btn day-check-button" :value="0">
          <v-icon class="day-check-icon" v-if="weekDays.includes(0)">mdi-check</v-icon>
          Domingo
        </v-btn>
      </v-btn-toggle>
    </div>

    <div v-if="!validStudyTime" class="schedule-length-message">
      <v-icon color="#F7B329" class="mr-2">mdi-alert-circle-outline</v-icon>
      <span>{{ controlMessage }}</span>
    </div>

    <div class="step-buttons d-flex flex-column flex-md-row justify-content-md-between mt-5">
      <v-btn rounded outlined class="btn previous-step-button only-button dark-button" large @click="previousStep">
        <v-icon class="mr-3">mdi-arrow-left</v-icon>
        Voltar
      </v-btn>

      <v-btn rounded class="btn next-step-button only-button primary-button mb-5 mb-md-0" large v-if="validStudyTime"
             color="#F47D3A"
             @click="isUpdate ? updateSchedule() : createSchedule()">
        {{ isUpdate ?  'Editar Cronograma' : 'Criar cronograma' }}
        <v-icon class="ml-3">mdi-arrow-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>

import './style.scss'
import {mapActions, mapGetters} from 'vuex'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import DateUtils from '@/core/utils/date-utils'

export default {
  name: 'StepFour',

  mounted() {
    this.dateRange = [this.scheduleStart, this.scheduleEnd]
    this.hours = Math.floor(this.scheduleDailyStudyTime / 3600)
    this.minutes = Math.floor(this.scheduleDailyStudyTime % 3600 / 60)
    this.validateStudyTime()
  },

  data() {
    return {
      dateMenu: false,
      timeMenu: false,
      hours: 0,
      minutes: 0,
      dateRange: [],
      allowedMinutes: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55],
      totalStudyTime: 0,
      errorMessage: '',
    }
  },

  computed: {
    ...mapGetters([
      'apiError',
      'agenda',
      'contentTime',
      'isUpdate',
      'loading',
      'scheduleDailyStudyTime',
      'scheduleEnd',
      'scheduleId',
      'scheduleStart',
      'scheduleWeekdays'
    ]),

    controlMessage() {
      let message = this.errorMessage !== '' ? this.errorMessage : this.totalContentTimeText

      return message + ' (Tempo de estudo atual: ' + Math.floor(this.totalStudyTime / 3600)
          + ' horas  e ' + Math.floor(this.totalStudyTime % 3600 / 60) + ' minutos)'
    },

    dateRangeText() {
      return this.dateRange[0] && this.dateRange[1] ? DateUtils.formatDate(this.dateRange[0], 'DD/MM/YY')
          + ' - ' + DateUtils.formatDate(this.dateRange[1], 'DD/MM/YY') : null
    },

    modalError: {
      get() {
        return !!this.apiError
      },

      set() {
        this.resetApiErrors()
      }
    },

    modalLoading: {
      get() {
        return this.loading
      },

      set(value) {
        value ? this.startLoading() : this.stopLoading()
      }
    },

    studyTime() {
      return this.hours > 0
          ? this.hours.toString().padStart(2, '0') + ':' + this.minutes.toString().padStart(2, '0')
          : null
    },

    totalContentTimeText() {
      return 'Você irá precisar de ' + Math.floor(this.contentTime / 3600)
          + ' horas  e ' + Math.floor(this.contentTime % 3600 / 60) + ' minutos para estudar o conteúdo.'
    },

    validStudyTime() {
      return this.weekDays.length > 0 && this.totalStudyTime > this.contentTime
    },

    weekDays: {
      get() {
        return this.scheduleWeekdays
      },

      set(value) {
        this.setScheduleWeekdays(value)
      }
    }
  },

  methods: {
    ...mapActions([
      'createSchedule',
      'resetApiErrors',
      'setCreationStep',
      'setScheduleDailyStudyTime',
      'setScheduleDates',
      'setScheduleWeekdays',
      'startLoading',
      'stopLoading',
      'updateSchedule'
    ]),

    previousStep() {
      this.setCreationStep(3)
    },

    validateDateRange() {
      this.dateMenu = false

      if (this.dateRange[0] && this.dateRange[1]) {
        if (DateUtils.getDifference(this.dateRange[0], this.dateRange[1]) > 0) {
          this.dateRange.reverse()
        }

        this.setScheduleDates(this.dateRange)
        this.$refs.dateMenu.save(this.dateRange)
        return true
      }

      return false
    },

    validateHoursMinutes() {
      if (this.hours > 0) {
        let dailyStudyTime = this.hours * 3600 + this.minutes * 60
        this.setScheduleDailyStudyTime(dailyStudyTime)
        this.validateStudyTime()
      }
    },

    validateDates() {
      if (!this.validateDateRange()) {
        this.errorMessage = this.errorMessage ?? ''
        return false
      }

      let valido = true
      let index = 0

      while (valido && index < this.agenda.length) {
        let cronograma = this.agenda[index]

        valido = this.agenda[index].id === this.scheduleId
            || DateUtils.getDifference(this.dateRange[0], cronograma.data_fim) > 0
            || DateUtils.getDifference(cronograma.data_inicio, this.dateRange[1]) > 0
        index++
      }

      this.errorMessage = valido ? '' : 'Você já possui um cronograma de estudo para essas datas. Por favor, escolha outra.'
      return valido
    },

    validateStudyTime() {
      if (this.validateDates()) {
        let interval = DateUtils.getDatesInInterval(this.dateRange[0], this.dateRange[1], 1, 'days')
        let studyDays = 0;
        interval.forEach(dia => {
          if (this.weekDays.includes(DateUtils.getWeekDay(dia) % 7)) {
            studyDays++;
          }
        })

        let dailyStudyTime = this.hours * 3600 + this.minutes * 60
        this.totalStudyTime = studyDays * dailyStudyTime

        this.errorMessage = this.validStudyTime
            ? ''
            : this.totalContentTimeText + ' Para continuar, diminua seus conteúdos ou aumente seu tempo de estudo.'
      }
    }
  }
}
</script>
